import map from "lodash/map";
import { orderBy } from "../../utils/collectionUtils";

const sort = (list) => orderBy(list, "tittel", "asc");

const LinkerView = ({ Linker, header }) => {
  const interne = Linker.interneLenker;
  const offentlige = Linker.offentligeLenker;
  const filressurser = Linker.filressurserLenker;
  return (
    <div>
      <div className="fake-label" style={{ fontSize: 16, fontWeight: "bold" }}>
        {header}
      </div>
      <h3>Interne linker</h3>
      {map(sort(interne), (item) => {
        return (
          <div className="16px-bold" key={item.tittel}>
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              {item.tittel}
            </a>
            <br />
            <br />
          </div>
        );
      })}
      <h3>Offentlige linker</h3>
      {map(sort(offentlige), (item) => {
        return (
          <div className="16px-bold" key={item.tittel}>
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              {item.tittel}
            </a>
            <br />
            <br />
          </div>
        );
      })}
      <h3>Filressurs linker</h3>
      {map(sort(filressurser), (item) => {
        return (
          <div className="16px-bold" style={{ width: 300 }} key={item.tittel}>
            <span>
              <a
                style={{ width: 150 }}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.tittel}
              </a>
            </span>
            <br />
            <br />
          </div>
        );
      })}
    </div>
  );
};

export default LinkerView;
